/**
 * Diccionario único de etiquetas legibles (español) del módulo de Productos.
 *
 * Regla: ninguna tabla, panel o tarjeta pinta la llave técnica del enum.
 * Todos los componentes de `pages/productos/**` deben importar de aquí.
 */
export function productoLabel(
  dict: Readonly<Record<string, string>>,
  key: string | null | undefined,
  fallback = '—'
): string {
  if (key === null || key === undefined || key === '') return fallback;
  return dict[key] ?? key;
}

/** Tipo de adjunto de un producto. */
export const ATTACHMENT_TYPE_LABELS: Readonly<Record<string, string>> = {
  document: 'Documento',
  video: 'Video',
  image: 'Imagen',
  other: 'Otro',
};

/** Método de cálculo de los precios escalonados. */
export const PRICING_METHOD_LABELS: Readonly<Record<string, string>> = {
  volume: 'Por volumen',
  step: 'Por tramo',
  graduated: 'Escalonado (acumulativo)',
  tiered: 'Escalonado',
};

/** Tipo de precio en una moneda del producto. */
export const PRICE_CURRENCY_TYPE_LABELS: Readonly<Record<string, string>> = {
  fixed: 'Precio fijo',
  calculated: 'Calculado por tipo de cambio',
};

/** Tipo de precio dentro de una lista de precios. */
export const PRICE_LIST_ITEM_TYPE_LABELS: Readonly<Record<string, string>> = {
  fixed: 'Precio fijo',
  discount_percent: 'Descuento porcentual',
  discount_amount: 'Descuento por monto',
};

/** Tipo de producto. */
export const PRODUCT_TYPE_LABELS: Readonly<Record<string, string>> = {
  inventory: 'Producto (inventariable)',
  non_inventory: 'Producto (no inventariable)',
  service: 'Servicio',
  bundle: 'Paquete',
  product: 'Producto',
};

/** Ciclo de facturación. */
export const BILLING_CYCLE_LABELS: Readonly<Record<string, string>> = {
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  biannual: 'Semestral',
  yearly: 'Anual',
  annual: 'Anual',
};

/** Condición de facturación. */
export const BILLING_CONDITION_LABELS: Readonly<Record<string, string>> = {
  auto_renew: 'Renovación automática',
  manual: 'Manual',
  on_completion: 'Al completar',
  prepaid: 'Prepago',
  postpaid: 'Pospago',
};
